import { useContext, useEffect, useState } from "react";
import { CheckOutlined } from "@ant-design/icons";

import BasicPlane from "../Icons/BasicPlane";
import BusinessPlane from "../Icons/BusinessPlane";
import EnterprisePlane from "../Icons/EnterprisePlane";
import "./subscriptions.less";
import { Button, message, Spin } from "antd";
import React from "react";
import UserContext, { AccountType } from "../themeContext/UserContext";
import { postUserDetails } from "../axios/portalData";
import axios, { AxiosError } from "axios";

const Subscriptions: React.FC = () => {
  const { userInfo, setUserInfo } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);

  const accountTypes: AccountType[] = ["free", "standard", "premium"];
  const index = accountTypes.indexOf(userInfo.accountType);
  // only splice array when item is found
  if (index > -1) {
    accountTypes.splice(index, 1); // 2nd parameter means remove one item only
  }

  const handleClickDone = (object: { accountType: AccountType }) => {
    setIsLoading(true);
    const value = object["accountType"] as AccountType;
    postUserDetails(object)
      .then((res) => {
        res.status == 200 ? message.success(res.data) : message.error(res.data);
        setUserInfo((userInfo) => {
          return { ...userInfo, accountType: value };
        });
        setIsLoading(false);
      })
      .catch((error: Error | AxiosError) => {
        if (axios.isAxiosError(error)) {
          console.log("AxiosError message: ", error);
          message.error(error.message);
          setIsLoading(false);
        } else {
          console.log("unexpected error: ", error);
          message.error("An unexpected error occurred");
          setIsLoading(false);
        }
      });
  };

  if (isLoading) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="subscription-main">
      <SubscriptionCard type={userInfo.accountType} isSelected handleClickDone={handleClickDone} />
      <SubscriptionCard type={accountTypes[0]} handleClickDone={handleClickDone} />
      <SubscriptionCard type={accountTypes[1]} handleClickDone={handleClickDone} />
      <div style={{ marginBottom: "100px" }} />
    </div>
  );
};

export default Subscriptions;

interface SubCardType {
  type: "free" | "standard" | "premium";
  handleClickDone: (object: { accountType: AccountType }) => void;
  isSelected?: boolean;
}
const SubscriptionCard: React.FC<SubCardType> = (props) => {
  const { type, handleClickDone, isSelected = false } = props;

  const [label, setLabel] = useState("");
  const [price, setPrice] = useState(0);
  const [description, setDescription] = useState("");
  const [features, setFeatures] = useState([""]);

  const RenderSVG = () => {
    if (type == "free") {
      return <BasicPlane />;
    } else if (type == "standard") {
      return <BusinessPlane />;
    } else {
      return <EnterprisePlane />;
    }
  };

  useEffect(() => {
    if (type == "free") {
      setLabel("Onramp Basic");
      setPrice(0);
      setDescription("This is the descirption for the FREE plan");
      setFeatures(["feature1", "feature 2"]);
    } else if (type == "standard") {
      setLabel("Onramp Business");
      setPrice(500);
      setDescription("This is the descirption for the STANDARD plan");
      setFeatures(["features from Basic", "feature 3", "feature 4"]);
    } else {
      setLabel("Onramp Enterprise");
      setPrice(1000);
      setDescription("This is the descirption for the PREMIUM plan");
      setFeatures(["features from Business", "feature 5", "feature 6", "feature 7", "feature 8"]);
    }
  }, [type]);

  return (
    <div className={isSelected ? "subscription-main-card selected" : "subscription-main-card"}>
      <div className="subscription-top">
        {isSelected && <div className="subscription-selected-block">Current Subscription</div>}
        <div className={isSelected ? "subscription-top-2 selected" : "subscription-top-2"}>
          <div className="subscription-type-text">{label}</div>
          {RenderSVG()}
        </div>
      </div>
      <div className={isSelected ? "subscription-content selected" : "subscription-content"}>
        <div className="subscription-description">{description}</div>
        <div style={{ width: "35%" }}>
          {features.map((feature, index: number) => {
            return (
              <div key={index}>
                <span style={{ fontSize: "17px" }}>
                  <CheckOutlined />
                </span>
                <span className="subscription-feature-text">{feature}</span>
              </div>
            );
          })}
        </div>
      </div>
      {isSelected ? (
        <></>
      ) : (
        <div>
          <hr style={{ margin: "0px 30px 0px 30px", color: "var(--gray-3)" }} />
          <div className="subscription-bottom">
            <div style={{ color: "var(--gray-1)" }}>
              <div style={{ font: "normal normal bold 34px/41px 'Roboto', sans-serif" }}>${price}</div>
              <div style={{ font: "normal normal normal 17px/20px 'Roboto', sans-serif" }}>
                /month (billed annually)
              </div>
            </div>
            <Button className="secondary-button" onClick={() => handleClickDone({ accountType: type })}>
              Select Plan
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
